// removed by extract-text-webpack-plugin
module.exports = {"root":"AccordionItemTitle__root___JG24i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItemTitle/AccordionItemTitle.scss
// module id = 1001
// module chunks = 0